/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationMembershipsIndexPathParams,
	OrganisationMembershipsIndexQueryParams,
	OrganisationMembershipsIndexResponse,
} from '../types/OrganisationMembershipsIndex'

/**
 * GET /organisations/:organisation/memberships
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationMembershipsController.php OrganisationMembershipsController::index
 */
export async function organisationMembershipsIndex(
	organisation: OrganisationMembershipsIndexPathParams['organisation'],
	params?: OrganisationMembershipsIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationMembershipsIndexResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/memberships`, { params, ...config })
}
